import React from 'react';
import AuthGate from './components/AuthGate';
import Graph from './components/Graph';
import CompanyPage from './components/CompanyPage';
import './App.css';
import './styles/global.css';
import './styles/responsive.css';

// No router in this app - ?company=<id> is the one standalone route, opened in a new tab from
// CompanyDetailPanel's "Open in a new tab" button, read once at load (a plain reload is already
// how the rest of the app handles navigation, so this doesn't need to react to URL changes).
const companyId = new URLSearchParams(window.location.search).get('company');

function App() {
  return (
    <div className="App" style={{ height: '100vh', width: '100vw', margin: 0, padding: 0 }}>
      <AuthGate>
        {companyId ? <CompanyPage companyId={Number(companyId)} /> : <Graph />}
      </AuthGate>
    </div>
  );
}

export default App;
